<template>
  <!-- viewbox 0 0 12 12 -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.44623 1.71967C3.73913 1.42678 4.214 1.42678 4.50689 1.71967L8.78722 6L4.50689 10.2803C4.214 10.5732 3.73913 10.5732 3.44623 10.2803C3.15334 9.98744 3.15334 9.51256 3.44623 9.21967L6.6659 6L3.44623 2.78033C3.15334 2.48744 3.15334 2.01256 3.44623 1.71967Z"
    fill="currentColor"
  />
</template>
